import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

/**
 * Interceptor to remove a specific cookie from outgoing API requests.
 * Adjust 'yourCookieName' and the URL matching as needed.
 */
@Injectable()
export class RemoveCookieInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Only intercept requests to the API (adjust as needed)
    if (!req.url.includes('/api/')) {
      return next.handle(req);
    }

    // Get the current Cookie header
    const cookieHeader = req.headers.get('Cookie');
    if (!cookieHeader) {
      return next.handle(req);
    }

    // Remove the specific cookie from the Cookie header
    const filteredCookie = cookieHeader
      .split(';')
      .map((cookie) => cookie.trim())
      .filter((cookie) => !cookie.startsWith('yourCookieName='))
      .join('; ');

    // Clone the request with the modified Cookie header
    const modifiedReq = req.clone({
      headers: req.headers.set('Cookie', filteredCookie),
    });

    return next.handle(modifiedReq);
  }
}
